<template>
  <section class="offer">
    <div class="container">
      <SectionTitle :title="$store.state.statics.Suggest" v-if="!hideTitle" />
      <div class="row">
        <OfferItem
          v-for="(item, index) in offers"
          :key="item.id || index"
          :offer="item"
          :svg-code="item.svgCode"
          :icon-url="item.iconUrl"
          :icon-color="item.iconColor"
          :index="index"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
import SectionTitle from "./../shared/SectionTitle";
import OfferItem from "./OfferItem";
export default {
  computed: {
    ...mapState({
      offers: (state) => state.offers.offers,
    }),
  },
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    OfferItem,
    SectionTitle,
  },
};
</script>
